import React from 'react';
import cn from 'classnames';
import { Link } from '@lt/components';

import { useTranslation } from '@lt/localization';
import { pluralizeReviews } from 'src/utils/pluralizeUtils';
import { Swiper, SwiperSlide } from 'swiper/react';

import SwipeReviewsCard from 'src/components/Reviews/ReviewCard/components/SwipeReviewCard/SwipeReviewCard';
import LinkButton from '../../../LinkButton';

import styles from './reviewsSwiper.module.css';
import type { ReviewsSwiperProps as Props } from './types';
import ShowReviewsButton from '../../OldReviewsComponents/ShowReviewsButton';
import { REVIEWS_SWIPER_CONTAINER } from './constants';

export const ReviewSwiper = ({
  totalReviews,
  items,
  isShowMoreVisible,
  isWhiteLabel,
  hotelReviewsLink,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  const ShowMoreButton = isWhiteLabel ? (
    <ShowReviewsButton totalReviews={totalReviews} />
  ) : (
    <LinkButton href={hotelReviewsLink}>
      {`${t('hotel.reviews.show')} ${totalReviews} ${pluralizeReviews(
        totalReviews,
      )}`}
    </LinkButton>
  );

  return (
    <div
      className={styles.swiperReviewsCard}
      data-testid={REVIEWS_SWIPER_CONTAINER}
    >
      <Swiper
        className={cn(styles.swiper, {
          [styles.swiperSlide]: items.length > 1,
        })}
        slidesPerView="auto"
        spaceBetween={8}
      >
        {items.map((item) => {
          const ReviewCard = (
            <SwipeReviewsCard
              key={item.id}
              content={item.content}
              name={item.name}
              createdAt={item.createdAt}
              averageRating={item.averageRating}
              avatarUrl={item.avatarUrl}
              title={item.title}
              images={item.images}
              className={styles.reviewsCard}
            />
          );
          return (
            <SwiperSlide key={`slide-${item.id}`}>
              {isWhiteLabel ? (
                <div>{ReviewCard}</div>
              ) : (
                <Link
                  href={hotelReviewsLink}
                  target="_blank"
                  style={{ color: '#17181A' }}
                >
                  {ReviewCard}
                </Link>
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>
      {isShowMoreVisible && (
        <div className={styles.showMoreContainer}>{ShowMoreButton}</div>
      )}
    </div>
  );
};
